(function () {
  'use strict';
  function init(root) {
    if (root.dataset.scgReady) return;
    root.dataset.scgReady = 'true';
    const abort = new AbortController(), signal = abort.signal;
    let observer, navObserver, imageObserver, historyFrame, initialFrame;
    root.scgCleanup = () => { abort.abort(); observer?.disconnect(); navObserver?.disconnect(); imageObserver?.disconnect(); cancelAnimationFrame(historyFrame); cancelAnimationFrame(initialFrame); delete root.dataset.scgReady; };
    if ('ResizeObserver' in window) {
      imageObserver = new ResizeObserver(entries => entries.forEach(({ target, contentRect }) => {
        if (target.matches('.scg-picks')) {
          const visible = [...target.querySelectorAll('.scg-pick')].filter(card => !card.hidden);
          const orphan = getComputedStyle(target).gridTemplateColumns.split(' ').length === 2 && visible.length === 3 ? visible.at(-1) : null;
          target.querySelectorAll('.scg-pick').forEach(card => card.classList.toggle('scg-pick--wide', card === orphan));
          return;
        }
        if (contentRect.width > 0) {
          const aspect = Number(target.dataset.sourceAspect) || 1;
          const coveredWidth = getComputedStyle(target).objectFit === 'cover' ? contentRect.height * aspect : 0;
          target.sizes = Math.ceil(Math.max(contentRect.width, coveredWidth)) + 'px';
        }
      }));
      root.querySelectorAll('.scg-pick-image img').forEach(img => imageObserver.observe(img));
      root.querySelectorAll('.scg-picks').forEach(grid => imageObserver.observe(grid));
    }
    const nav = root.querySelector('.scg-nav');
    if (nav && 'ResizeObserver' in window) {
      navObserver = new ResizeObserver(() => {
        root.style.setProperty('--scg-nav-height', window.matchMedia('(min-width:1200px)').matches ? '0px' : Math.ceil(nav.getBoundingClientRect().height) + 'px');
        watchChapters();
      });
      navObserver.observe(nav);
    }
    root.querySelectorAll('img[data-fallback]').forEach(img => {
      const recover = () => {
        if (img.dataset.recovered) return;
        img.dataset.recovered = 'true'; img.removeAttribute('srcset'); img.src = img.dataset.fallback;
      };
      img.addEventListener('error', recover, { signal });
      if (img.complete && !img.naturalWidth) recover();
    });
    const jump = root.querySelector('[data-chapter-jump]'), go = root.querySelector('[data-chapter-go]');
    if (jump) jump.disabled = false;
    if (go) go.disabled = false;
    let pendingChapter = false, starterValue = '';
    const findTarget = value => [...root.querySelectorAll('[id]')].find(el => '#' + el.id === value);
    const currentTarget = () => { try { return findTarget(decodeURIComponent(location.hash)); } catch { return null; } };
    const chapters = jump ? [...jump.options].map(option => findTarget(option.value)).filter(Boolean) : [];
    const sideLinks = [...root.querySelectorAll('[data-career-nav]')];
    function markChapter(chapter) {
      const href = '#' + chapter.id;
      const skip = root.querySelector('[data-skip-guide]');
      if (skip) skip.href = href;
      sideLinks.forEach(link => {
        if (link.getAttribute('href') === href) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      const active = sideLinks.find(link => link.getAttribute('href') === href);
      if (nav && active) nav.style.setProperty('--scg-nav-accent', active.style.getPropertyValue('--career'));
      if (active && nav && !nav.contains(document.activeElement) && window.matchMedia('(min-width:1200px)').matches) {
        const item = active.getBoundingClientRect(), frame = nav.getBoundingClientRect();
        // Keep the current chapter in the sidebar without scrolling the document.
        if (item.top < frame.top + 12) nav.scrollTop += item.top - frame.top - 12;
        else if (item.bottom > frame.bottom - 12) nav.scrollTop += item.bottom - frame.bottom + 12;
      }
    }
    const branchChapters = [...root.querySelectorAll('[data-branch-chapter]')];
    const cardOrder = new Map([...root.querySelectorAll('[data-current-pick]')].map((card, index) => [card, index]));
    const compareControls = new Map();
    root.querySelectorAll('[data-compare-toggle]').forEach(button => {
      const comparison = findTarget('#' + button.getAttribute('aria-controls'));
      if (!comparison?.matches('details.scg-comparison')) return;
      compareControls.set(comparison, button);
      comparison.dataset.enhanced = 'true';
      const sync = () => {
        button.hidden = comparison.hidden;
        button.setAttribute('aria-expanded', String(comparison.open));
        const rows = [...comparison.querySelectorAll('tbody tr')].filter(row => !row.hidden);
        const names = rows.map(row => row.querySelector('th').textContent.trim());
        button.setAttribute('aria-label', `${comparison.open ? 'Close' : 'Compare'} ${names.join(', ')}`);
        button.title = button.getAttribute('aria-label');
        comparison.querySelector('.scg-comparison-heading p').textContent = names.join(' / ');
        const label = comparison.id.endsWith('mining-comparison') ? 'Compare Golem & Prospector' : comparison.id.endsWith('racing-comparison') ? 'Compare M50 & Razor' : 'Compare ships';
        button.lastChild.textContent = comparison.open ? 'Close comparison' : label;
      };
      button.addEventListener('click', () => { comparison.open = !comparison.open; sync(); }, { signal });
      comparison.addEventListener('toggle', sync, { signal });
      const close = comparison.querySelector('[data-compare-close]');
      if (close) {
        close.hidden = false;
        close.addEventListener('click', () => { comparison.open = false; sync(); button.focus(); }, { signal });
      }
      comparison.scgSync = sync;
      sync();
    });
    const choices = [...root.querySelectorAll('[data-starter-choice]')];
    const originalCards = choices.map(button => [...root.querySelectorAll('[data-pick]')].find(n => n.dataset.pick === button.dataset.starterChoice)).filter(Boolean);
    const originalRows = choices.map(button => [...root.querySelectorAll('[data-starter-row]')].find(n => n.dataset.starterRow === button.dataset.starterChoice)).filter(Boolean);
    const stateKey = root.id.replace(/-root$/, '');
    let copy = {};
    try { copy = JSON.parse(root.querySelector('[data-starter-copy]').textContent); } catch { /* Other controls do not depend on starter copy. */ }

    function promote(nodes, value, attribute) {
      if (!nodes.length) return;
      const ordered = [...nodes.filter(n => n.dataset[attribute] === value), ...nodes.filter(n => n.dataset[attribute] !== value)];
      const parent = nodes[0].parentElement;
      if (ordered.every((n, i) => parent.children[i] === n)) return;
      const focused = parent.contains(document.activeElement) ? document.activeElement : null;
      parent.append(...ordered);
      focused?.focus({ preventScroll: true });
    }
    function selectStarter(value) {
      starterValue = choices.some(button => button.dataset.starterChoice === value) ? value : '';
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.starterChoice === starterValue)));
      originalCards.forEach(card => card.classList.toggle('is-recommended', !!starterValue && card.dataset.pick === starterValue));
      originalRows.forEach(row => row.classList.toggle('is-recommended', !!starterValue && row.dataset.starterRow === starterValue));
      const feedback = root.querySelector('[data-choice-result]');
      if (feedback) feedback.textContent = copy[starterValue] || '';
      promote(originalCards, starterValue, 'pick');
      promote(originalRows, starterValue, 'starterRow');
    }
    function groupActivityCards(chapter, value = '') {
      const groups = chapter.querySelector('[data-current-groups]');
      if (!groups) return;
      const cards = [...groups.querySelectorAll('[data-current-pick]')];
      for (const card of cards) {
        const tiers = JSON.parse(card.dataset.activityTiers || '{}');
        const tier = tiers[value] || card.dataset.defaultTier;
        const grid = groups.querySelector(`[data-price-tier="${tier}"] .scg-picks`);
        if (grid && card.parentElement !== grid) grid.append(card);
      }
      groups.querySelectorAll('.scg-price-tier').forEach(tier => {
        const grid = tier.querySelector('.scg-picks');
        const ordered = [...grid.children].sort((a, b) => cardOrder.get(a) - cardOrder.get(b));
        if (ordered.some((card, index) => grid.children[index] !== card)) grid.append(...ordered);
        const visible = [...grid.querySelectorAll('.scg-pick')].filter(pick => !pick.hidden);
        grid.dataset.visibleCount = String(visible.length);
        tier.hidden = !visible.length;
      });
    }
    function selectBranch(chapter, value, announce = false) {
      const buttons = [...chapter.querySelectorAll('[data-branch-choice]')];
      if (!buttons.some(button => button.dataset.branchChoice === value)) return;
      chapter.dataset.activeBranch = value;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.branchChoice === value)));
      chapter.querySelectorAll('[data-branches]').forEach(item => { item.hidden = !item.dataset.branches.split(' ').includes(value); });
      groupActivityCards(chapter, value);
      const count = [...chapter.querySelectorAll('[data-current-pick]')].filter(pick => !pick.hidden).length;
      chapter.querySelectorAll('[data-current-groups] .scg-price-tier').forEach(tier => {
        const grid = tier.querySelector('.scg-picks');
        const visible = [...grid.querySelectorAll('.scg-pick')].filter(pick => !pick.hidden).length;
        grid.dataset.visibleCount = String(visible);
        tier.hidden = !visible;
      });
      const comparison = chapter.querySelector('.scg-comparison');
      if (comparison) {
        comparison.hidden = [...comparison.querySelectorAll('tbody tr')].filter(row => !row.hidden).length < 2;
        if (comparison.hidden) comparison.open = false;
        const toggle = compareControls.get(comparison);
        if (toggle) { toggle.hidden = comparison.hidden; toggle.setAttribute('aria-expanded', String(comparison.open)); }
        comparison.scgSync?.();
      }
      const message = `${count} ${count === 1 ? 'recommendation' : 'recommendations'}`;
      chapter.querySelector('[data-pick-count]').textContent = message;
      if (announce) chapter.querySelector('[data-branch-feedback]').textContent = buttons.find(button => button.dataset.branchChoice === value).textContent + ': ' + message;
    }
    function readState() {
      try {
        const raw = new URL(location.href).searchParams.get(stateKey);
        if (!raw || raw.length > 4096) return {};
        const state = JSON.parse(raw);
        return state && !Array.isArray(state) && state.v === 1 ? state : {};
      } catch { return {}; }
    }
    function writeState(mode = 'replace', hash, readingChapter) {
      const focus = Object.fromEntries(branchChapters.filter(chapter => chapter.dataset.activeBranch !== chapter.querySelector('[data-branch-choice]').dataset.branchChoice).map(chapter => [chapter.dataset.branchChapter, chapter.dataset.activeBranch]));
      const url = new URL(location.href);
      if (Object.keys(focus).length || starterValue) url.searchParams.set(stateKey, JSON.stringify({ v: 1, focus, starter: starterValue }));
      else url.searchParams.delete(stateKey);
      if (hash !== undefined) url.hash = hash;
      if (url.href !== location.href) {
        let state = history.state;
        if (mode === 'push' && readingChapter) {
          state = { ...state, scgReading: { root: stateKey, id: readingChapter.id, top: readingChapter.getBoundingClientRect().top, x: scrollX } };
          history.replaceState(state, '', location.href);
        }
        history[mode === 'push' ? 'pushState' : 'replaceState'](state, '', url);
      }
    }
    function restoreState() {
      const state = readState();
      branchChapters.forEach(chapter => {
        const buttons = [...chapter.querySelectorAll('[data-branch-choice]')];
        const saved = state.focus?.[chapter.dataset.branchChapter];
        selectBranch(chapter, buttons.some(b => b.dataset.branchChoice === saved) ? saved : buttons[0].dataset.branchChoice);
      });
      selectStarter(state.starter);
    }
    function revealTarget(target) {
      const chapter = target.closest('[data-branch-chapter]'), member = target.closest('[data-branches]');
      if (chapter && member?.hidden) { selectBranch(chapter, member.dataset.branches.split(' ')[0]); writeState(); }
      if (chapter && target.matches('.scg-comparison') && target.hidden) {
        const button = [...chapter.querySelectorAll('[data-branch-choice]')].find(b => [...chapter.querySelectorAll('.scg-comparison tbody tr')].filter(n => n.dataset.branches.split(' ').includes(b.dataset.branchChoice)).length > 1);
        if (button) { selectBranch(chapter, button.dataset.branchChoice); writeState(); }
      }
      for (let parent = target; parent && parent !== root; parent = parent.parentElement) if (parent.tagName === 'DETAILS') parent.open = true;
    }
    function syncTarget(target) {
      revealTarget(target);
      const chapter = chapters.find(chapter => chapter === target || chapter.contains(target));
      if (!chapter) return;
      pendingChapter = false; jump.value = '#' + chapter.id;
      markChapter(chapter);
    }
    function syncHash() {
      if (!location.hash) { pendingChapter = false; if (jump) jump.selectedIndex = 0; if (chapters[0]) markChapter(chapters[0]); return; }
      const target = currentTarget();
      if (target) { syncTarget(target); target.scrollIntoView({ block: 'start', behavior: 'instant' }); }
    }
    branchChapters.forEach(chapter => {
      chapter.querySelectorAll('[data-branch-choice]').forEach(button => button.addEventListener('click', () => {
        selectBranch(chapter, button.dataset.branchChoice, true);
        const target = currentTarget();
        // Do not retain a card anchor that contradicts the newly selected focus.
        const hiddenTarget = target && chapter.contains(target) && (target.closest('[data-branches]')?.hidden || target.closest('.scg-comparison')?.hidden);
        writeState('push', hiddenTarget || !target || !chapter.contains(target) ? chapter.id : undefined, chapter);
      }, { signal }));
      chapter.querySelector('[data-branch-controls]').hidden = false;
      chapter.querySelector('[data-change-focus]').hidden = false;
    });
    choices.forEach(button => button.addEventListener('click', () => {
      selectStarter(button.getAttribute('aria-pressed') === 'true' ? '' : button.dataset.starterChoice);
      const chapter = button.closest('[data-chapter]'), target = currentTarget();
      writeState('push', !target || !chapter.contains(target) ? chapter.id : undefined, chapter);
    }, { signal }));
    const selector = root.querySelector('[data-starter-selector]');
    if (selector) selector.hidden = false;
    restoreState(); syncHash();
    const initialHref = location.href;
    let initialNavigation = true;
    for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) window.addEventListener(type, () => { initialNavigation = false; }, { once: true, passive: true, signal });
    const loaded = document.readyState === 'complete' ? Promise.resolve() : new Promise(resolve => window.addEventListener('load', resolve, { once: true, signal }));
    Promise.all([loaded, document.fonts?.ready]).then(() => {
      // Fonts and the first responsive layout can move a deep-linked chapter after init.
      // Never realign once the reader has started interacting or moved elsewhere.
      if (signal.aborted) return;
      initialFrame = requestAnimationFrame(() => { initialFrame = requestAnimationFrame(() => {
        if (!signal.aborted && initialNavigation && location.href === initialHref && location.hash) syncHash();
      }); });
    });
    let historyHref = '';
    window.addEventListener('popstate', () => {
      restoreState();
      const target = currentTarget();
      const position = history.state?.scgReading;
      const anchor = position?.root === stateKey && Number.isFinite(position.top) && Number.isFinite(position.x) && findTarget('#' + position.id);
      if (anchor || target) syncTarget(anchor || target);
      // History restores the actual reading position, which can differ from an old fragment.
      historyHref = location.href;
      pendingChapter = false;
      watchChapters();
      if (anchor) {
        cancelAnimationFrame(historyFrame);
        historyFrame = requestAnimationFrame(() => {
          window.scrollTo({ top: scrollY + anchor.getBoundingClientRect().top - position.top, left: position.x, behavior: 'instant' });
        });
      }
    }, { signal });
    window.addEventListener('hashchange', () => {
      if (historyHref === location.href) { historyHref = ''; return; }
      historyHref = '';
      restoreState(); syncHash();
    }, { signal });
    root.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
      let hash;
      try { hash = decodeURIComponent(url.hash); } catch { return; }
      const target = findTarget(hash);
      if (target) {
        if (link.dataset.targetBranch) {
          const chapter = target.closest('[data-branch-chapter]');
          if (chapter) {
            event.preventDefault();
            // Save the old reading position before applying a purpose-specific route.
            const previous = { ...history.state, scgReading: { root: stateKey, id: link.closest('[data-chapter]')?.id || target.id, top: (link.closest('[data-chapter]') || target).getBoundingClientRect().top, x: scrollX } };
            history.replaceState(previous, '', location.href);
            selectBranch(chapter, link.dataset.targetBranch, true);
            writeState('push', target.id);
            history.replaceState({ ...history.state, scgReading: { root: stateKey, id: target.id, top: parseFloat(getComputedStyle(target).scrollMarginTop) || 0, x: scrollX } }, '', location.href);
          }
        }
        syncTarget(target);
        if (link.hasAttribute('data-change-focus')) {
          event.preventDefault(); location.hash = target.id;
          target.scrollIntoView({ block: 'start', behavior: 'instant' });
          target.querySelector('[aria-pressed="true"]')?.focus({ preventScroll: true });
        }
        if (link.matches('[data-career-nav],[data-reading-link],[data-skip-guide],[data-recommendation-link]')) {
          event.preventDefault(); location.hash = target.id;
          target.tabIndex = -1; target.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }
    }, { signal });
    jump?.addEventListener('change', () => { pendingChapter = true; }, { signal });
    go?.addEventListener('click', () => {
      const target = findTarget(jump.value);
      if (!target) return;
      pendingChapter = false; location.hash = target.id;
      target.tabIndex = -1; target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }, { signal });
    function watchChapters() {
      if (!('IntersectionObserver' in window) || !jump || !chapters.length) return;
      observer?.disconnect();
      const readingLine = () => Math.min(Math.max(0, innerHeight - 2), Math.max(0, Math.round(parseFloat(getComputedStyle(chapters[0]).scrollMarginTop) || 0)));
      const line = readingLine();
      observer = new IntersectionObserver(() => {
        const line = readingLine();
        const positions = chapters.map(chapter => ({ chapter, rect: chapter.getBoundingClientRect() }));
        // Track the first readable line below the real header, not a viewport percentage.
        const current = positions.find(p => p.rect.top <= line + 2 && p.rect.bottom > line)?.chapter || positions.filter(p => p.rect.top <= line).at(-1)?.chapter;
        if (current) {
          markChapter(current);
          if (!pendingChapter && document.activeElement !== jump && document.activeElement !== go) jump.value = '#' + current.id;
        }
      }, { rootMargin: `-${line}px 0px -${Math.max(0, innerHeight - line - 2)}px 0px`, threshold: 0 });
      chapters.forEach(chapter => observer.observe(chapter));
    }
    watchChapters();
    window.addEventListener('resize', watchChapters, { signal });
    root.querySelectorAll('[data-matrix-state]').forEach(link => {
      try {
        const target = new URL(link.href, location.href);
        target.searchParams.set('ibg', JSON.stringify(JSON.parse(link.dataset.matrixState))); target.hash = ''; link.href = target.href;
      } catch { /* Keep the server-rendered link if an editor supplies an invalid URL. */ }
    });
    let printState = [];
    window.addEventListener('beforeprint', () => {
      printState = [...root.querySelectorAll('details,[data-branches],.scg-price-tier')].map(el => [el, el.open, el.hidden]);
      printState.forEach(([el]) => { if (el.tagName === 'DETAILS') el.open = true; el.hidden = false; });
      branchChapters.forEach(chapter => groupActivityCards(chapter));
    }, { signal });
    window.addEventListener('afterprint', () => {
      printState.forEach(([el, open, hidden]) => { if (el.tagName === 'DETAILS') el.open = open; el.hidden = hidden; }); printState = [];
      branchChapters.forEach(chapter => groupActivityCards(chapter, chapter.dataset.activeBranch));
    }, { signal });
  }
  const mount = parent => parent.querySelectorAll('[data-ship-career-guide]').forEach(init);
  mount(document);
  if (!window.__scgEvents) {
    window.__scgEvents = true;
    document.addEventListener('shopify:section:load', event => mount(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ship-career-guide]').forEach(root => root.scgCleanup?.()));
  }
})();
